import { useQuery } from '@tanstack/react-query';
import type { WizerConnectorDetailsResponse } from '../../api/connectors/connectors.api';
import { getWizerConnectorDetails } from '../../api/connectors/connectors.api';

const useWizerQuery = ({
  cbid,
  email,
  accountId,
}: {
  cbid?: string;
  email?: string;
  accountId?: string;
}) => {
  return useQuery<WizerConnectorDetailsResponse, Error>({
    queryKey: ['wizer-training', { accountId, cbid, userEmail: email }],
    queryFn: () =>
      getWizerConnectorDetails({ params: { cbid, userEmail: email } }).then(
        (response) => response.data
      ),
    retry: false,
    enabled: !!accountId && !!cbid && !!email,
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 15, // 15 minutes
  });
};

export default useWizerQuery;
